import { render } from "./MainNav.vue?vue&type=template&id=50252389&scoped=true"
import script from "./MainNav.vue?vue&type=script&lang=js"
export * from "./MainNav.vue?vue&type=script&lang=js"

import "./MainNav.vue?vue&type=style&index=0&id=50252389&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50252389"]])

export default __exports__